import { useSelector } from "react-redux";
import { Createdocumenttype } from "../../../store/documenttype-store/documenttype-actions";
import DocumenttypeForms from "../../../components/Forms/DocumenttypeForms";

const DocumenttypeCreate = () => {
  const documenttype = useSelector((state) => state.documenttype.documenttype);

  return (
    <>
    <div style={{ backgroundColor: "#133047", padding: "1%", height: "62.5rem" }}>
      <DocumenttypeForms actionDocumenttype={Createdocumenttype} documenttype={documenttype} />
    </div>
    </>
  );
};
export default DocumenttypeCreate;
